import type { ProductType } from '../payment.types';

export const getSubmitButtonLabel = (productType: ProductType) => {
  switch (productType) {
    // case 'TreasuryProductPlus':
    //   return 'Activate Plus';
    // case 'TreasuryProductAdFree':
    //   return 'Activate Ad-Free';
    case 'TreasuryProductBattlePass':
      return 'Activate Pass';
    case 'TreasuryProductXPBooster':
      return 'Activate XP Booster';
  }
};
